import debounce from '~/utils/events/debounce';
import {setLoading} from '../Store/creators/common';
import {appendItems} from '../Store/creators/listData';
import {dispatch} from '../Store/index';
import sendListRequest from '../utils/sendListRequest';

/**
 * Загружает элементы в список вместо текущих.
 * 
 * @param query Строка параметров запроса.
 */
async function fetchListMore( query: string ): Promise<void>
{
	dispatch( setLoading( true ) );
	
	const {listData} = await sendListRequest( query );
	
	dispatch(
		appendItems(
			listData.items,
			listData.itemsLeft,
			listData.nextItemsOffset,
		),
	);
	dispatch( setLoading( false ) );
}

/**
 * Загружает элементы в список вместо текущих.
 * Ограничен по частоте срабатываний.
 * 
 * @param query Строка параметров запроса.
 */
const debouncedFetchListMore = debounce( fetchListMore, 200 );

/**
 * Module.
 */
export {
	fetchListMore as default,
	debouncedFetchListMore,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/asyncActions/fetchListMore.ts